import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { scopedCollection } from '../server/scoped-collection.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { ParticipationEinzelberatung } from '../entities/ParticipationEinzelberatung.js';

export const getParticipationsEinzelberatungByProductID = registerQuery({
  operationName: 'getParticipationsEinzelberatungByProductID',
  type: () => [ParticipationEinzelberatung],
  params: [{ name: 'productID', type: () => String }],
  resolve: (productID: string) => {
    return async (gqlFields: BaseQLSelectionSet<ParticipationEinzelberatung>) => {
      const collection = await scopedCollection<ParticipationEinzelberatung>(ParticipationEinzelberatung._class);
      const result = await collection.find<ParticipationEinzelberatung>({ productID }).toArray();
      return result;
    };
  },
});
